import LaporanRekapitulasiPendapatanApi from "./LaporanRekapitulasiPendapatanApi";

export default LaporanRekapitulasiPendapatanApi;
